import { observer } from "mobx-react";
import React, { useState, SyntheticEvent, useEffect } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import SlidingPanel from "react-sliding-side-panel";
import fotaFileTypeEnum from "../../../constants/fota-file-type-enum";
import userSettingEnum from "../../../constants/user-setting-enum";
import { useStore } from "../../../contexts/StoreProvider";
import IPageInfo, { IPageLimitInfo } from "../../../models/ICommon";
import { IFotaTenantReleaseList } from "../../../models/response/IFotaResponse";
import { ISchedulerHistoryList } from "../../../models/response/IReleaseSchedulerHistoryResponse";
import FormLoader from "../../../shared-components/FormLoader/FormLoader";
import RoutesConstants from "../../../shared-components/Routes/routes.constants";
import { formatMessage } from "../../../translations/format-message";
import config from "../../../helpers/config-helper";
import Grid from "../../../shared-components/Grid/Grid";
import Pagination from "../../../shared-components/Grid/Pagination";
import no_user from "../../../assets/Images/svg/no-user.svg";
import {
  DATE_TIME_FORMAT,
  DATE_TIME_FORMAT_FILENAME,
  emptyValue,
  emptyValueHyphen,
} from "../../../constants/common-constants";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import LoaderIconButton from "../../../shared-components/Button/LoaderIconButton";
import {
  IDeviceFotaStatusList,
  IDeviceFotaStatusListVm,
} from "../../../models/response/IFotaSchedulerDeviceStatusResponse";
import moment from "moment";
import Papa from "papaparse";
import { isOperationPermitted } from "../../../helpers/action-permission-helper";
import systemModuleEnum from "../../../constants/system-module-enum";
import FotaDeviceStatusFilterForm from "../forms/fota-device-status-filter-form";
import FilterPopupHOC from "../../../shared-components/popup/filter/filter-popup-hoc";
import _ from "lodash";

const appConfig = config();

const FotaSchedulerDeviceStatus = (props: any) => {
  const { preferencesStore, releaseSchedulerHistoryStore, fotaStore } =
    useStore();
  const {
    error,
    schedulerDeviceStatusListState,
    reset,
    GetFotaSchedulerDeviceStatusListService,
    getFotaSchedulerDeviceStratusList,
    resetSchedulerDeviceStatusListState,
    schedulerDeviceStatusList,
    resetStore,
    filterDetails,
    setFilterDetail,
  } = releaseSchedulerHistoryStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const { isSelectedView } = fotaStore;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const selectedRecord: ISchedulerHistoryList | null = props.location?.state
    ? props.location.state.selectedRecord
    : null;
  const selectedSchedulerRecord: IFotaTenantReleaseList | null = props.location
    ?.state
    ? props.location.state.selectedScheduler
    : null;
  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: schedulerDeviceStatusList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.FotaLimitConfig, parseInt(evt.target.value));
  };

  /**
   * This function calls the "GetFotaMzlReleaseListService" store funtion that get fota release list from API
   */
  const callGetFotaDeviceStatusListService = () => {
    if (selectedRecord?.Id)
      GetFotaSchedulerDeviceStatusListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        isSelectedView,
        selectedRecord.Id,
        filterDetails
      );
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetFotaDeviceStatusListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: schedulerDeviceStatusList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFotaSchedulerDeviceStratusList]);

  useEffect(() => {
    return () => {
      resetStore();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (filterDetails.isFilterActive) callGetFotaDeviceStatusListService();
    else {
      callGetFotaDeviceStatusListService();
    }
  }, [filterDetails]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetFotaDeviceStatusListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaDeviceStatusListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedId && row.Id === selectedId) {
      className = "bg-row SelectedRow";
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const closePanelhandler = () => {
    resetSchedulerDeviceStatusListState();
    setOpenPanel(false);
    setSelectedId(0);
    setSelectedRow({});
    // tenantStore.reset();
  };

  /**
   * This function provides manual refresh functionality
   * This function is used when we give refresh functionality to user.
   */
  const refreshClickHandler = () => {
    callGetFotaDeviceStatusListService();
  };

  //   const downloadCSVHandler = () => {
  //     callGetFotaDeviceStatusListService();
  //   };

  const downloadCSVHandler = () => {
    const currentDate = new Date();
    const deviceListToExport = getFotaSchedulerDeviceStratusList.map(
      (deviceStatus: IDeviceFotaStatusList) => {
        return {
          ICCID: deviceStatus.ICCID,
          TotalSegment: deviceStatus.TotalSegment,
          LastSegmentNoRequestedByDevice:
            deviceStatus.LastSegmentNoRequestedByDevice,
          LastRequestTimestamp:
            deviceStatus.LastRequestTimestamp !== emptyValue
              ? moment(deviceStatus.LastRequestTimestamp).format(
                  DATE_TIME_FORMAT
                )
              : "",
          Status: formatMessage(deviceStatus.Status),
        };
      }
    );
    const csv = Papa.unparse(deviceListToExport);
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      moment(currentDate).format(DATE_TIME_FORMAT_FILENAME) +
      " DevicesFotaStatus.csv";
    document.body.appendChild(a);
    a.click();
    toast.success(formatMessage("download_started_successfully"));
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const columns: any = [
    {
      dataField: "Id",
      text: "label_id",
      hidden: true,
    },
    {
      dataField: "ICCID",
      text: formatMessage("iccid"),
    },
    {
      dataField: "TotalSegment",
      text: formatMessage("total_segment"),
      formatter: (cell: any, row: any) => {
        return (
          <span>
            {
              <span>
                {row?.LastSegmentNoRequestedByDevice}/{cell}
              </span>
            }
          </span>
        );
      },
    },
    {
      dataField: "LastRequestTimestamp",
      text: formatMessage("last_request_timestamp"),
      formatter: (cell: any, row: any) => {
        return (
          <span>
            {
              (selectedRecord?.ScheduleDate && new Date(selectedRecord?.ScheduleDate) < new Date()) ?
              <span>
                {cell}
              </span> : emptyValueHyphen
            }
          </span>
        );
      },
    },
    {
      dataField: "LastRebootMessage",
      text: formatMessage("last_reboot_message"),
      title: (cell: string, row: any) => {
        return (cell?.length > 20 && selectedRecord?.ScheduleDate && new Date(selectedRecord?.ScheduleDate) < new Date()) ? cell : undefined;
      },
      formatter: (cell: any, row: any) => {
        return (
          <span>
            {
              (selectedRecord?.ScheduleDate && new Date(selectedRecord?.ScheduleDate) < new Date()) ?
              <span>
                {cell}
              </span> : emptyValueHyphen
            }
          </span>
        );
      },
    },
    // {
    //   dataField: "Status",
    //   text: formatMessage("status"),
    //   formatter: (cell: any, row: any) => {
    //     return (
    //       <span>
    //         {
    //           <span
    //             className={`btn btn-sm btn-${
    //               devicesFotaStatusClasses[row.StatusValue]
    //             }`}
    //           >
    //             <FormattedMessage id={cell} />
    //           </span>
    //         }
    //       </span>
    //     );
    //   },
    // },
  ];

  const openFilterPopUpHandler = () => {
    props.filterToggleHandler();
  };

  const closeFilterPopupHandler = () => {
    props.filterToggleHandler();
  };

  const filterSubmitHandler = (values: any) => {
    closeFilterPopupHandler();
    setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true });
    setFilterDetail({ ...values, isFilterActive: true });
    closePanelhandler();
  };

  const resetFilter = () => {
    closePanelhandler();
    setFilterDetail({
      SearchBy: -1,
      ICCID: "",
      Status: 0,
      isFilterActive: false,
    });
    setPageInfo({ ...pageInfo, currentPage: 1, isRefreshPage: true });
  };

  return (
    <>
      {props.showFilterPopup && (
        <FotaDeviceStatusFilterForm
          initialValues={_.omit(filterDetails, ["isFilterActive"])}
          isFilterActive={filterDetails.isFilterActive}
          submitHandler={filterSubmitHandler}
          modalClosed={closeFilterPopupHandler}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-8 col-12">
                <div className="filter-left-area ps-5">
                  <ul className="d-flex align-items-center mt-1">
                    <li title={formatMessage("back")}>
                      <button
                        role=""
                        className="btn btn-secondary"
                        onClick={() =>
                          props.history.push({
                            pathname: RoutesConstants.FotaHistory,
                            state: {
                              selectedRecord: { ...selectedSchedulerRecord },
                            },
                          })
                        }
                      >
                        <i className="fa fa-arrow-left"></i>
                      </button>
                    </li>
                    <li className="ms-2">
                      <p className="h5 mb-0 d-inline">
                        <FormattedMessage id="fota_device_status" />
                      </p>
                      {
                          selectedSchedulerRecord?.Id &&
                          <small className="text-muted ms-2">
                            (<span className="me-2"><FormattedMessage id="version" />: {selectedSchedulerRecord?.Version}</span> |
                            <span className="mx-2"><FormattedMessage id="file_type" />: {fotaFileTypeEnum[selectedSchedulerRecord?.FileType]}</span> |
                            <span className="ms-2"><FormattedMessage id="schedule_date_utc" />: {selectedRecord?.ScheduleDate}</span>)
                          </small>
                        }
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-4 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    <li className="" title={formatMessage("refresh")}>
                      <LoaderIconButton
                        id="RefreshDevicesStatus"
                        onClick={() => refreshClickHandler()}
                        svg={
                          <svg
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-arrow-repeat m-0"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                            <path
                              fillRule="evenodd"
                              d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
                            />
                          </svg>
                        }
                        className="mx-1"
                        variant="light"
                      />
                    </li>
                    {filterDetails.isFilterActive == true ? (
                      <li>
                        <button
                          data-testid="FilterButton"
                          className="btn btn-light mx-2"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          onClick={resetFilter}
                          title={formatMessage("reset_filter")}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            id="Layer_1"
                            x="0px"
                            y="0px"
                            width="20px"
                            height="20px"
                            viewBox="0 0 122.88 110.668"
                            enableBackground="new 0 0 122.88 110.668"
                          >
                            <g>
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M91.124,15.645c12.928,0,23.406,10.479,23.406,23.406 c0,12.927-10.479,23.406-23.406,23.406c-12.927,0-23.406-10.479-23.406-23.406C67.718,26.125,78.197,15.645,91.124,15.645 L91.124,15.645z M2.756,0h117.322c1.548,0,2.802,1.254,2.802,2.802c0,0.848-0.368,1.622-0.996,2.139l-10.667,13.556 c-1.405-1.375-2.95-2.607-4.614-3.672l6.628-9.22H9.43l37.975,46.171c0.59,0.516,0.958,1.254,0.958,2.102v49.148l21.056-9.623 V57.896c1.651,1.9,3.548,3.582,5.642,4.996v32.133c0,1.105-0.627,2.064-1.586,2.506l-26.476,12.758 c-1.327,0.773-3.023,0.332-3.798-1.033c-0.258-0.441-0.368-0.92-0.368-1.4V55.02L0.803,4.756c-1.07-1.106-1.07-2.839,0-3.945 C1.355,0.258,2.056,0,2.756,0L2.756,0z M96.93,28.282c1.328-1.349,3.489-1.355,4.825-0.013c1.335,1.342,1.341,3.524,0.013,4.872 l-5.829,5.914l5.836,5.919c1.317,1.338,1.299,3.506-0.04,4.843c-1.34,1.336-3.493,1.333-4.81-0.006l-5.797-5.878l-5.807,5.889 c-1.329,1.349-3.489,1.355-4.826,0.013c-1.335-1.342-1.341-3.523-0.013-4.872l5.83-5.913l-5.836-5.919 c-1.317-1.338-1.3-3.507,0.04-4.843c1.339-1.336,3.492-1.333,4.81,0.006l5.796,5.878L96.93,28.282L96.93,28.282z"
                              />
                            </g>
                          </svg>
                        </button>
                      </li>
                    ) : (
                      ""
                    )}
                    <li data-testid="Filter">
                      <div className="dropdown">
                        <button
                          data-testid="FilterButton"
                          className="btn btn-light mx-2"
                          type="button"
                          onClick={openFilterPopUpHandler}
                          title={formatMessage("filter")}
                        >
                          <svg
                            className="svg-icon"
                            width="20px"
                            height="20px"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M859.02 234.524l0.808-0.756 0.749-0.813c27.047-29.356 33.876-70.34 17.823-106.957-15.942-36.366-50.416-58.957-89.968-58.957H163.604c-38.83 0-73.043 22.012-89.29 57.444-16.361 35.683-10.632 76.301 14.949 106.004l0.97 1.126 280.311 266.85 2.032 312.074c0.107 16.502 13.517 29.805 29.995 29.805l0.2-0.001c16.568-0.107 29.912-13.626 29.804-30.194l-2.198-337.564-296.478-282.241c-9.526-11.758-11.426-26.933-5.044-40.851 6.446-14.059 19.437-22.452 34.75-22.452h624.828c15.6 0 28.69 8.616 35.017 23.047 6.31 14.391 3.924 29.831-6.354 41.497l-304.13 284.832 1.302 458.63c0.047 16.54 13.469 29.916 29.998 29.915h0.087c16.568-0.047 29.962-13.517 29.915-30.085L573.04 502.36l285.98-267.836z"
                              fill="currentColor"
                            />
                            <path
                              d="M657.265 595.287c0 16.498 13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.498 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997H687.262c-16.498 0-29.997 13.499-29.997 29.997z m273.894 138.882H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z m0 168.878H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z"
                              fill="currentColor"
                            />
                          </svg>
                        </button>
                      </div>
                    </li>
                    {isOperationPermitted(systemModuleEnum.Fota, "View") && (
                      <li
                        title={formatMessage("export_fota_devices_status")}
                        className={`mx-2 ${
                          getFotaSchedulerDeviceStratusList.length == 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <LoaderButton
                          id="ExportAllDevicesStatus"
                          text="export_fota_devices_status"
                          disabled={
                            getFotaSchedulerDeviceStratusList.length == 0
                          }
                          onClick={downloadCSVHandler}
                        />
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="table_items_list">
        {schedulerDeviceStatusListState.inProgress && (
          <FormLoader loading={schedulerDeviceStatusListState.inProgress} />
        )}
        {getFotaSchedulerDeviceStratusList.length > 0 ? (
          <div
            className={`card mt-3 changingPanel ${
              openPanel ? "panelOpen" : ""
            }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                <Grid
                  data={getFotaSchedulerDeviceStratusList}
                  columns={columns}
                  keyField="Id"
                  loading={schedulerDeviceStatusListState.inProgress}
                  // rowEvents={{ onClick: rowEvents }}
                  rowClasses={rowClassFormat}
                />
              </div>
            </div>

            {getFotaSchedulerDeviceStratusList.length > 0 ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              <FormattedMessage id="no_schedule_history" />
            </p>
            <p className="mb-3">
              {formatMessage(
                filterDetails.isFilterActive
                  ? "no_schedule_history_after_filter_msg"
                  : "no_schedule_history_msg"
              )}
            </p>
          </div>
        )}
      </div>
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel order_details_panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">
                {selectedRow.EffectiveDateTimestamp}
              </h2>
            </div>
            <div className="col-lg-1 text-end">
              <button
                onClick={closePanelhandler}
                className="Crossicons"
                title={formatMessage("close")}
              >
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(observer(FotaSchedulerDeviceStatus));
